@if (!currentPath.startsWith('/auth')) {
  <app-header></app-header>
}

<main [class.flex-fill]="!currentPath.startsWith('/auth')">
  <router-outlet></router-outlet>
<!--  <app-chat-widget></app-chat-widget>-->
</main>

@if (!currentPath.startsWith('/auth')) {
  <app-footer></app-footer>
}
<app-chat-widget></app-chat-widget>
<app-cookie-consent></app-cookie-consent>
